/*
 * Tela de login.
 *
 * A folha de 40 linhas de `!important` que ficava aqui foi REMOVIDA: ela estilizava
 * o formulario por dentro, mirando classes internas do MUI
 * (`.MuiInputBase-root`, `.MuiInput-underline:before`, `.MuiInputLabel-shrink`).
 * Qualquer renomeacao dessas classes numa subida de versao devolveria a tela ao
 * visual padrao SEM erro de build - falha silenciosa. O estilo agora esta dentro
 * do proprio LoginForm, em Tailwind.
 *
 * O `AuthLayout` (ilustracao, selos, fundo) nao foi tocado.
 */
import GuestGuard from '../../guards/GuestGuard';
import Page from '../../components/Page';
import { LoginForm } from '../../sections/auth/login';
import AuthLayout from '../../sections/auth/AuthLayout';

const headerContent = (
  <div className="mb-6 text-center">
    <h1 className="m-0 text-[24px] font-extrabold tracking-[-0.4px] text-ink">Bem-vindo ao GPShub</h1>
    <p className="mb-0 mt-2 text-[12.5px] leading-[1.55] text-muted-foreground">
      Gerencie dispositivos e políticas corporativas com segurança
    </p>
  </div>
);

export default function Login() {
  return (
    <GuestGuard>
      <Page title="Login - GPShub">
        {/* Sem `footer`: o rodape de confianca agora e do AuthLayout, com o selo
            de SSL, a versao e o aviso de ambiente - e em tokens.
            O que existia aqui era um bloco proprio com cores literais (#E8EEF7,
            #1E88E5, #8CA0BC), um dos ultimos das telas de auth: ignorava o tema
            escuro e, depois do rodape novo, DUPLICAVA a linha de SSL na tela. */}
        <AuthLayout headerContent={headerContent} maxFormWidth={500}>
          <LoginForm />
        </AuthLayout>
      </Page>
    </GuestGuard>
  );
}
